import { CaeImportError } from '@configuration/assistants/cae-assistant/cae-import-error-collector';

export class CaeImportException extends Error {
  public constructor(
    public caeError: CaeImportError,
  ) {
    super();
  }
}
